import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { GamesState, Game } from "../../types";

const initialState: GamesState = {
  playerWaitlist: {},
  playerCurrentGame: {},
  numPlayers: 0,
  currentGame: {},
  publicCashList: null,
  publicTourneyList: null,
  privateCashList: null,
  privateTourneyList: null,
  // New unified games structure
  allGames: null,
  gamesLoading: false,
  gamesError: null,
};

const gamesSlice = createSlice({
  name: "games",
  initialState,
  reducers: {
    setPublicCashList: (state, action: PayloadAction<Record<string, Game>>) => {
      state.publicCashList = action.payload;
    },
    setPublicTourneyList: (
      state,
      action: PayloadAction<Record<string, Game>>,
    ) => {
      state.publicTourneyList = action.payload;
    },
    setPrivateCashList: (
      state,
      action: PayloadAction<Record<string, Game>>,
    ) => {
      state.privateCashList = action.payload;
    },
    setPrivateTourneyList: (
      state,
      action: PayloadAction<Record<string, Game>>,
    ) => {
      state.privateTourneyList = action.payload;
    },
    setPlayerWaitlist: (state, action: PayloadAction<Record<string, Game>>) => {
      state.playerWaitlist = action.payload;
    },
    setPlayerCurrentGame: (
      state,
      action: PayloadAction<Record<string, Game>>,
    ) => {
      state.playerCurrentGame = action.payload;
    },
    setNumPlayersList: (state, action: PayloadAction<number>) => {
      state.numPlayers = action.payload;
    },
    // New unified actions
    setAllGames: (state, action: PayloadAction<Record<string, Game>>) => {
      state.allGames = action.payload;
      state.gamesLoading = false;
      state.gamesError = null;
      
      // Also update individual lists for backward compatibility
      const games = action.payload;
      const publicCash: Record<string, Game> = {};
      const publicTourney: Record<string, Game> = {};
      const privateCash: Record<string, Game> = {};
      const privateTourney: Record<string, Game> = {};
      
      Object.values(games).forEach((game) => {
        if (game.access === "Public" && game.type === "Cash") {
          publicCash[game.id] = game;
        } else if (game.access === "Public" && game.type === "Tournament") {
          publicTourney[game.id] = game;
        } else if (game.access === "Private" && game.type === "Cash") {
          privateCash[game.id] = game;
        } else if (game.access === "Private" && game.type === "Tournament") {
          privateTourney[game.id] = game;
        }
      });
      
      state.publicCashList = publicCash;
      state.publicTourneyList = publicTourney;
      state.privateCashList = privateCash;
      state.privateTourneyList = privateTourney;
    },
    setGamesLoading: (state, action: PayloadAction<boolean>) => {
      state.gamesLoading = action.payload;
    },
    setGamesError: (state, action: PayloadAction<string | null>) => {
      state.gamesError = action.payload;
      state.gamesLoading = false;
    },
  },
});

export const {
  setPublicCashList,
  setPublicTourneyList,
  setPrivateCashList,
  setPrivateTourneyList,
  setPlayerWaitlist,
  setPlayerCurrentGame,
  setNumPlayersList,
  // New unified actions
  setAllGames,
  setGamesLoading,
  setGamesError,
} = gamesSlice.actions;
export default gamesSlice.reducer;
